'use client';

import clsx from 'clsx';
import styles from './ServiceLogoHeader.module.scss';

type ServiceLogoHeaderProps = {
  logoSize?: 'small' | 'medium' | 'large';
  justify?: 'center' | 'flex-start';
  justifyPc?: 'center' | 'flex-start';
};

/**
 * サービスロゴヘッダー
 * 各種ページで共通使用するロゴヘッダーコンポーネント
 */
function ServiceLogoHeader({ logoSize = 'medium', justify = 'center', justifyPc }: ServiceLogoHeaderProps) {
  const logoClass = clsx(styles.logo, styles[logoSize]);

  const headerClass = clsx(styles.header, styles[justify], justifyPc && styles[`${justifyPc}Pc`]);

  return (
    <div className={headerClass}>
      <img src='/logo.png' alt='ジャンプLAB' className={logoClass} />
    </div>
  );
}

export default ServiceLogoHeader;
